"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_native_1 = require("react-native");
var TAPS_DELAY = 300;
exports.DoubleTapView = function (_a) {
    var children = _a.children, onDoubleTap = _a.onDoubleTap;
    var _b = react_1.useState(false), wasPressedOnce = _b[0], setWasPressedOnce = _b[1];
    var _c = react_1.useState(0), firstPressMoment = _c[0], setFirstPressMoment = _c[1];
    var onPressView = function () {
        if (wasPressedOnce) {
            if (new Date().getTime() - firstPressMoment < TAPS_DELAY) {
                onDoubleTap && onDoubleTap();
            }
            setWasPressedOnce(false);
            setFirstPressMoment(0);
        }
        else {
            setFirstPressMoment(new Date().getTime());
            setWasPressedOnce(true);
        }
    };
    return (react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { onPress: onPressView, style: { zIndex: 99 } }, children));
};
